export default {
  type: process.env.REACT_APP_LEGACY_SERVICE_TYPE,
  endpoints: {
    legacy: {
      root: process.env.REACT_APP_LEGACY_SERVICE_ROOT,
      users: process.env.REACT_APP_LEGACY_SERVICE_USERS,
      customerServiceBookings: process.env.REACT_APP_LEGACY_SERVICE_CUSTOMERSERVICE_BOOKINGS,
      customerServiceBookingsFullData: process.env.REACT_APP_LEGACY_SERVICE_CUSTOMERSERVICE_BOOKINGS_FULL_DATA,
      customerServiceMarkets: process.env.REACT_APP_LEGACY_SERVICE_CUSTOMERSERVICE_MARKETS,
      customerServiceMarket: process.env.REACT_APP_LEGACY_SERVICE_CUSTOMERSERVICE_MARKET,
      customerServiceEUMarkets: process.env.REACT_APP_LEGACY_SERVICE_CUSTOMERSERVICE_EU_MARKETS,
      customerServiceEventHistoryBooking: process.env.REACT_APP_LEGACY_SERVICE_CUSTOMERSERVICE_EVENTHISTORY_BOOKING,
      extension: process.env.REACT_APP_LEGACY_SERVICE_EXTENSION,
      availabilities: process.env.REACT_APP_LEGACY_SERVICE_AVAILABILITIES,
      bookings: process.env.REACT_APP_LEGACY_SERVICE_BOOKINGS,
      dealerships: process.env.REACT_APP_LEGACY_SERVICE_DEALERSHIPS,
      comments: process.env.REACT_APP_LEGACY_SERVICE_COMMENTS,
      sendbird: process.env.REACT_APP_LEGACY_SERVICE_SENDBIRD,
      userreports: process.env.REACT_APP_SERVICE_USERREPORTS,
      historylog: process.env.REACT_APP_LEGACY_SERVICE_HISTORYLOG,
      colab: process.env.REACT_APP_LEGACY_SERVICE_COLAB,
      management: process.env.REACT_APP_LEGACY_SERVICE_UPDATE_MANAGEMENT,
    },
    main: {
      root: process.env.REACT_APP_SERVICE_ROOT,
      users: process.env.REACT_APP_SERVICE_USERS,
      customerServiceBookings: process.env.REACT_APP_SERVICE_BOOKINGS,
      extension: process.env.REACT_APP_LEGACY_SERVICE_EXTENSION,
      availabilities: process.env.REACT_APP_LEGACY_SERVICE_AVAILABILTIES,
      bookings: process.env.REACT_APP_LEGACY_SERVICE_BOOKINGS,
      userreports: process.env.REACT_APP_SERVICE_USERREPORTS,
    },
  },
};
